import { render, staticRenderFns } from "./goods_freeget.vue?vue&type=template&id=346b5804&scoped=true"
import script from "./goods_freeget.vue?vue&type=script&lang=js"
export * from "./goods_freeget.vue?vue&type=script&lang=js"
import style0 from "./goods_freeget.vue?vue&type=style&index=0&id=346b5804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b5804",
  null
  
)

export default component.exports